export default "__VITE_ASSET__BtBHU_6d__"